import { Button, ButtonProps, Typography } from '@mui/material';

type Props = ButtonProps & {
	label: string;
	to: string;
};

const ButtonLink: React.FC<Props> = props => {
	const { label, to, ...otherProps } = props;
	return (
		<Button
			startIcon={props.startIcon}
			disableElevation
			disableTouchRipple
			disableRipple
			disableFocusRipple
			variant="linkDark"
			type="button"
			href={to}
			target="_blank"
			sx={otherProps.sx}
		>
			<Typography variant="button">{label}</Typography>
		</Button>
	);
};

export default ButtonLink;
